import './style.scss'

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

import Arrow from './arrow'

const REM_BASE = 16
const EXTRA_HEIGHT = 2.25

const AccordionItem = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [elementHeight, setChildHeight] = useState('0')
  const contentRef = useRef(null)

  const toggle = () => setIsOpen(!isOpen)

  const updateHeight = () => {
    if (contentRef.current) {
      const elementHeightRaw = contentRef.current.clientHeight
      const elementHeightInRem = `${elementHeightRaw / REM_BASE + EXTRA_HEIGHT}rem`
      setChildHeight(elementHeightInRem)
    }
  }

  useEffect(() => {
    if (!isOpen) return

    updateHeight()
    const handleResize = () => updateHeight()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [isOpen])

  return (
    <div className={`accordion-item${isOpen ? ' active' : ''}`}>
      <div className='question-container' onClick={toggle}>
        <div className='question'> {ReactHtmlParser(faq.content1.description)}</div>
        <button className='accordion-toggle' aria-expanded={isOpen}>
          <Arrow direction={isOpen ? 'down' : 'up'} />
        </button>
      </div>
      <div
        className='content'
        style={{
          maxHeight: isOpen ? elementHeight : 0
        }}
      >
        <span className='answer' ref={contentRef}>
          {ReactHtmlParser(faq.content2.description)}
        </span>
      </div>
    </div>
  )
}

const FaqAccordion = ({ contents, hasContentAfterReviews, title }) => {
  return (
    <div className={`faq-wrapper${!hasContentAfterReviews ? ' faq-margin-bottom' : ''}`}>
      <div className='faq'>
        <h1 className='faq-title'>{title}</h1>
        {contents.map((faq, index) => (
          <AccordionItem key={index} faq={faq[1].contents} />
        ))}
      </div>
    </div>
  )
}

export default FaqAccordion

FaqAccordion.propTypes = {
  contents: PropTypes.array,
  hasContentAfterReviews: PropTypes.bool,
  title: PropTypes.string
}

AccordionItem.propTypes = {
  faq: PropTypes.object
}
